<template>
  <div class="section-header" v-if="currentIndex > 0" :key="currentIndex">
    <span class="title5">{{indexKorean}} 항목</span>
    <span class="title2">{{sectionTitle}}</span>

    <span v-if="getSectionDescription() !== ''" class="title3" >
      {{ getSectionDescription() }}
    </span>
    <div class="birth-info"
         v-if="isWeb === false
            && isSajuKeyIncluded
            && birthInfos && currentSection?.sectionType
            && birthInfos.length > 1
            && (currentSection.sectionType === 'personalInfo' || currentSection.sectionType === 'partnerInfo')"

         @click="openBirthInfoPopup">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.8652 12.7308C18.0781 12.7308 18.2563 12.6589 18.4 12.5153C18.5435 12.3718 18.6152 12.1936 18.6152 11.9808C18.6152 11.7679 18.5435 11.5898 18.4 11.4463C18.2563 11.3026 18.0781 11.2308 17.8652 11.2308H14.827C14.6142 11.2308 14.4359 11.3026 14.2923 11.4463C14.1488 11.5898 14.077 11.7679 14.077 11.9808C14.077 12.1936 14.1488 12.3718 14.2923 12.5153C14.4359 12.6589 14.6142 12.7308 14.827 12.7308H17.8652ZM17.8652 9.84625C18.0781 9.84625 18.2563 9.77442 18.4 9.63075C18.5435 9.48725 18.6152 9.30908 18.6152 9.09625C18.6152 8.88342 18.5435 8.70517 18.4 8.5615C18.2563 8.418 18.0781 8.34625 17.8652 8.34625H14.827C14.6142 8.34625 14.4359 8.418 14.2923 8.5615C14.1488 8.70517 14.077 8.88342 14.077 9.09625C14.077 9.30908 14.1488 9.48725 14.2923 9.63075C14.4359 9.77442 14.6142 9.84625 14.827 9.84625H17.8652ZM9.0385 13.1538C8.46417 13.1538 7.96092 13.1999 7.52875 13.2923C7.09675 13.3846 6.71342 13.5314 6.37875 13.7327C6.07375 13.9109 5.84242 14.1103 5.68475 14.3308C5.52692 14.5513 5.448 14.7878 5.448 15.0402C5.448 15.2148 5.515 15.3606 5.649 15.4777C5.783 15.5951 5.94875 15.6538 6.14625 15.6538H11.9308C12.1283 15.6538 12.2939 15.5909 12.4277 15.4653C12.5617 15.3398 12.6287 15.1847 12.6287 15C12.6287 14.7743 12.5515 14.5554 12.397 14.3433C12.2425 14.1311 12.0095 13.9276 11.698 13.7327C11.3635 13.5314 10.9802 13.3846 10.548 13.2923C10.116 13.1999 9.61283 13.1538 9.0385 13.1538ZM9.0385 11.8463C9.52433 11.8463 9.93742 11.676 10.2777 11.3355C10.6182 10.9952 10.7885 10.5821 10.7885 10.0962C10.7885 9.61025 10.6182 9.19708 10.2777 8.85675C9.93742 8.51642 9.52433 8.34625 9.0385 8.34625C8.55267 8.34625 8.1395 8.51642 7.799 8.85675C7.45867 9.19708 7.2885 9.61025 7.2885 10.0962C7.2885 10.5821 7.45867 10.9952 7.799 11.3355C8.1395 11.676 8.55267 11.8463 9.0385 11.8463ZM4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775ZM4.30775 18H19.6923C19.7693 18 19.8398 17.9679 19.9038 17.9038C19.9679 17.8398 20 17.7692 20 17.6923V6.30775C20 6.23075 19.9679 6.16025 19.9038 6.09625C19.8398 6.03208 19.7693 6 19.6923 6H4.30775C4.23075 6 4.16025 6.03208 4.09625 6.09625C4.03208 6.16025 4 6.23075 4 6.30775V17.6923C4 17.7692 4.03208 17.8398 4.09625 17.9038C4.16025 17.9679 4.23075 18 4.30775 18Z" fill="#1E2352"/>
      </svg>
      사주정보 불러오기
    </div>
  </div>
</template>

<script>
import {logEvent} from "@/tarot_box/helper/native_api";

export default {
  name: "InputHeader.vue",
  props: {
    inputSections: {
      type: Array,
    },
    currentIndex: {
      type: Number,
    },
    userName: {
      type: String,
    },
    isChecker: {
      type: Boolean,
      default: false,
    },
    isWeb: {
      type: Boolean,
      default: true,
    },
    birthInfos: {
      type: Object,
      default: null,
    },
    currentSection: {
      type: Object,
    },
    isSajuKeyIncluded: {
      type: Boolean,
      default: false,
    },
    presetName: {
      type: Object,
      default: () => ({
        personalInfo: '',
        partnerInfo: ''
      })
    },
  },
  computed: {
    indexKorean() {
      const index = this.currentIndex - 1;
      const indexKorean = ['첫번째', '두번째', '세번째', '네번째', '다섯번째'];
      return indexKorean[index];
    },
    sectionTitle() {
      const sectionIndex = this.currentIndex - 1;
      const section = this.inputSections[sectionIndex];
      if (!section) return '';

      const sectionType = section.sectionType;
      const subject = section.subject;

      if(this.isChecker) {
        switch (sectionType) {
          case 'personalInfo':
            if (!subject || subject === '나') {
              return this.presetName?.personalInfo
                  ? `${this.presetName.personalInfo}님의 정보를 확인해주세요`
                  : '고객님의 정보를 확인해주세요';
            }
            return `${this.presetName?.personalInfo
                ? ``
                : ''}${subject}의 정보를 확인해주세요`;
          case 'partnerInfo':
            if (!subject || subject === '상대방') {
              return this.presetName?.partnerInfo
                  ? `상대방의 정보를 확인해주세요`
                  : '상대방의 정보를 확인해주세요';
            }
            return `${subject}의 정보를 확인해주세요`;
          default:
            return `추가 입력한 정보를 확인하세요`;
        }
      } else {
        switch (sectionType) {
          case 'personalInfo':
            if (!subject || subject === '나') {
              return this.presetName?.personalInfo
                  ? `${this.presetName.personalInfo}님에 대한 정보를 알려주세요`
                  : '고객님에 대한 정보를 알려주세요';
            }
            return `${subject}에 대한 정보를 알려주세요`;
          case 'partnerInfo':
            if (!subject || subject === '상대방') {
              return this.presetName?.partnerInfo
                  ? `상대방에 대한 정보를 알려주세요`
                  : '상대방에 대한 정보를 알려주세요';
            }
            return `${subject}에 대한 정보를 알려주세요`;
          case 'additionalInfo':
            return `더욱 정확한 해석을 위해 구체적인 상황을 알려주세요`;
          default:
            return section.sectionTitle;
        }
      }
    }
  },
  methods : {
    getSectionDescription() {
      const sectionIndex = this.currentIndex - 1;
      const sectionType = this.inputSections[sectionIndex]?.sectionType;
      const sectionDescription = this.inputSections[sectionIndex]?.sectionDescription;

      if(['additionalInfo', 'personalInfo', 'partnerInfo'].includes(sectionType)) {
        return ''; // 또는 다른 적절한 기본값
      }
      return sectionDescription || ''; //
    },
    openBirthInfoPopup() {
      if(this.inputSections[this.currentIndex - 1].sectionType === 'personalInfo') {
        logEvent('boxinput_myinfo_sajulist_click', {});
        logEvent('boxinput_myinfo_sajulist_open', {});
      } else {
        logEvent('boxinput_otherinfo_sajulist_click', {});
        logEvent('boxinput_otherinfo_sajulist_open', {});
      }
      this.$emit('open-birth-info-popup');
    }
  }
}
</script>

<style scoped>
.section-header {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
  padding: 42px 0 0 0;
  line-height: 120%;
  animation: fadeInDown 0.5s ease-out;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.title2 {
  font-size: 24px;
  margin-top: 8px;
  margin-bottom: 12px;
  word-break: keep-all;
}

.birth-info{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 4px 16px;
  box-sizing: border-box;
  margin-bottom: 12px;
  background: var(--Color-palette-Primary-Lighten4);
  border-radius: 50px;
  gap: 4px;
  font-size: 14px;
  color: var(--Color-palette-Primary-Default);
  font-weight: 600;
  line-height: 1;
}
</style>